import { Flex } from 'portal-commons';
import { CSSProperties, FunctionComponent } from 'react';
import { Dialog, DialogContent, makeStyles } from '@material-ui/core';

interface ModalProps {
  style?: CSSProperties;
  open?: boolean;
  testId?: string;
}

const useStyles = makeStyles({
  backdrop: {
    backdropFilter: 'blur(1px)',
  },
  container: {
    marginLeft: '170px',
  },
  content: {
    width: '525px',
    padding: '28px 30px 9px 30px !important',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
});

const Modal: FunctionComponent<ModalProps> = ({
  style,
  open = false,
  testId,
  children,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      classes={{
        root: classes.backdrop,
        container: classes.container,
      }}
      maxWidth={false}
      open={open}
      data-testid={testId}
    >
      <DialogContent classes={{ root: classes.content }} style={style}>
        <Flex
          sx={{
            flexDirection: 'column',
            alignItems: 'center',
            rowGap: '8px',
            background: '#FFFFFF',
          }}
        >
          {children}
        </Flex>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
